module.exports = __webpack_public_path__ + "static/media/item4.ec23d993.jpg";